import { UI, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { getDaysDifferenceFromTodayText } from '../../../../../../../../../utils/getDaysDifferenceFromTodayText';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useFixedIncomeAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/FixedIncome';
import { useGlobalProductContext } from '../../../../../contexts';
import { availableProductFixedIncomeConstant } from '../constants';

import { FixedIncomeListItemTypes } from '.';

export const FixedIncomeListItemDesktop: React.FC<FixedIncomeListItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = useFixedIncomeAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const getFlex = (index: number) => {
    const currentHead = availableProductFixedIncomeConstant.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']} h="80px">
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <UI.Tooltip testID="details-tooltip" label={'Veja mais detalhes\nsobre este produto'}>
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
        </UI.Tooltip>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <VStack pr={Spacing['inline.xxxs']} space={Spacing['stack.quarck']}>
          <TableContentItemText>{offer.productDisplayNormalized}</TableContentItemText>
          <TableContentItemCaptions icons={offer.captions} />
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <VStack>
          <TableContentItemText>
            {Utils.Mask.Money(offer.applicationMinimumAmount)}
          </TableContentItemText>
          <TableContentItemText fontSize={Typography['fontsize.xs']}>
            Max {Utils.Mask.Money(offer.applicationMaximumAmount)}
          </TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <VStack>
          <TableContentItemText>{offer.maturityDateNormalized}</TableContentItemText>
          <TableContentItemText fontSize={Typography['fontsize.xs']}>
            {getDaysDifferenceFromTodayText(offer.maturityDate)}
          </TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <VStack>
          <TableContentItemText>{offer.dueDateNormalized}</TableContentItemText>
          <TableContentItemText fontSize={Typography['fontsize.xs']}>
            {getDaysDifferenceFromTodayText(offer.dueDate)}
          </TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{offer.liquidityIndicatorNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>
          {offer.profitabilityFormattedNormalized || '--'}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>
          {Utils.Mask.Percentage(offer.profitabilityToMaturity)}
        </TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};
